export default "__VITE_ASSET__PdJAemiY__"